module.exports = require("./ff-Adlm.d.ts");